var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 1rem 0 1rem"}},[_c('layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('PageHeader',{attrs:{"title":"ข้อมูลผู้เข้าเรียน"}})]},proxy:true},{key:"body",fn:function(){return [_c('studentInfo',{attrs:{"apiRoute":`/v1/analytics/tfac/get-student-info-overview`,"perPage":20}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }